import type { Market } from "@config/site/types";
import { getPagePathByLocale, shoppingBagPage } from "@lib/constants/pagePaths";
import { useStore } from "@store/store";
import { useIsomorphicLayoutEffect } from "@ui/hooks/useIsomorphicLayoutEffect";
import { useRouter } from "next/router";
import { useEffect } from "react";

const DEFAULT_LIMIT = 10;

type Config = {
    shouldRedirect?: boolean;
};

export const useOrderItemsLimit = (country: string, config?: Config) => {
    const setItemsLimitReached = useStore((state) => state.setItemsLimitReached);
    const cart = useStore((state) => state.data.me.cartInfo.cart);
    const itemsLimitReached = useStore((state) => state.data.me.cartInfo.itemsLimitReached);
    const { push, locale } = useRouter();

    const exceptionLimits: Partial<Record<Market, number>> = {
        // Define only exceptions — rest will fallback to DEFAULT_LIMIT
    };

    const getItemsLimit = (country: string) =>
        exceptionLimits[country.toLowerCase() as Market] ?? DEFAULT_LIMIT;

    const itemsLimit = getItemsLimit(country);

    const redirectBackToBag = () => {
        push(`${getPagePathByLocale(shoppingBagPage, locale)}`);
    };

    useEffect(() => {
        const itemsCount = cart?.lineItems?.reduce((total, item) => total + item.quantity, 0) ?? 0;
        setItemsLimitReached(itemsCount > itemsLimit);
    }, [cart, itemsLimit]);

    useIsomorphicLayoutEffect(() => {
        if (!config?.shouldRedirect || !itemsLimitReached) return;
        redirectBackToBag();
    }, [itemsLimitReached]);

    return {
        itemsLimit,
    };
};
